/** Arabic text with Latin digits (docs/design/27_calendar.md §10.8); the tag is also FullCalendar's locale code. */
export const ARABIC_LATIN_DIGITS = 'ar-u-nu-latn';

/** The Intl locale the app formats dates and numbers with: Arabic always uses Latin digits, so every screen agrees. */
export function intlLocale(lang: string): string {
  return lang === 'ar' ? ARABIC_LATIN_DIGITS : lang || 'en';
}
